import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import { UserTrialStatusChipKollegeUserFragmentDoc } from '../../../../features/okane-kollege/UserTrialStatusChip/UserTrialStatusChip.generated';
import { UserCourseStatusChipKollegeUserFragmentDoc } from '../../../../features/okane-kollege/UserCourseStatusChip/UserCourseStatusChip.generated';
export type OkaneKollegeUserListItemKollegeUserFragment = { __typename?: 'KollegeUser', id: string, isAntiSocial?: boolean | null, email?: { __typename?: 'KollegeUserEmail', email: string, isActivated: boolean } | null, profile?: { __typename?: 'KollegeUserProfile', id: string, familyName: string, givenName: string } | null, standardCourse?: { __typename?: 'KollegeUserCourse_StandardV20250418', status: Types.KollegeUserCourseStatus, lastCompletedLesson?: { __typename?: 'KollegeUserCourseLesson', schedule?: { __typename?: 'KollegeSchedule', startsAt: TimeString } | null } | null, period?: { __typename?: 'UserCoursePeriod', startsAt: TimeString, endsAt: TimeString } | null, expenseRecordDailyLesson?: { __typename?: 'KollegeExpenseRecordDailyLesson', period?: { __typename?: 'KollegeExpenseRecordDailyLessonPeriod', startsAt: TimeString, endsAt: TimeString } | null } | null } | null, trials: Array<{ __typename?: 'KollegeUserTrial', status: Types.KollegeUserTrialStatus, schedule?: { __typename?: 'KollegeSchedule', startsAt: TimeString } | null }> };

export const OkaneKollegeUserListItemKollegeUserFragmentDoc = gql`
    fragment OkaneKollegeUserListItemKollegeUser on KollegeUser {
  id
  email {
    email
    isActivated
  }
  isAntiSocial
  profile {
    id
    familyName
    givenName
  }
  standardCourse {
    lastCompletedLesson {
      schedule {
        startsAt
      }
    }
    period {
      startsAt
      endsAt
    }
    expenseRecordDailyLesson {
      period {
        startsAt
        endsAt
      }
    }
  }
  ...UserTrialStatusChipKollegeUser
  ...UserCourseStatusChipKollegeUser
}
    ${UserTrialStatusChipKollegeUserFragmentDoc}
${UserCourseStatusChipKollegeUserFragmentDoc}`;